module.exports = __webpack_public_path__ + "img/sleeve upper arm width.43e397d8.png";